module.exports = __webpack_public_path__ + "static/media/s15.17bb10cc.png";